import React from 'react';
import { Link } from "react-router-dom";

export default ({selected, menuItems}) => (
	<div id="nav">
        {menuItems.map((item, i) => (
		    item.get('isInDesktopNav') 
            && 
            <Link key={i} to={item.get('link')} className={selected === item.get('label') ? ' nav--link nav-selected' : 'nav--link'}>
                {item.get('label')}
            </Link>
        ))}
	</div>
)



// WEBPACK FOOTER //
// ./src/components/Nav.js